const API_BASE_URL = '';

export interface AnalyticsKpi {
  dispatches_count: number;
  dispatches_safe_capacity: number;
  saturation_percentage: number;
  queued_count: number;
  is_engine_paused: boolean;
  total_groups: number;
  total_members: number;
  total_capacity: number;
  occupancy_percentage: number;
  total_clicks: number;
}

export interface BreakdownItem {
  name: string;
  count: number;
  percentage: number;
  color: string;
}

export interface TopOfferItem {
  id: string;
  title: string;
  marketplace: string;
  image_url?: string | null;
  promotional_price: number | null;
  clicks_count: number;
  status: string;
}

export interface AffiliateIntegrationStatus {
  platform: string;
  connected: boolean;
  configured_account: string | null;
  estimated_commission_brl: number | null;
}

export interface DashboardAlertItem {
  id: string;
  type: 'warning' | 'danger' | 'info';
  title: string;
  message: string;
  action_label?: string | null;
  action_tab?: string | null;
}

export interface DashboardAnalyticsResponse {
  period: string;
  kpis: AnalyticsKpi;
  marketplaces_breakdown: BreakdownItem[];
  channels_breakdown: BreakdownItem[];
  top_offers: TopOfferItem[];
  affiliate_integrations: AffiliateIntegrationStatus[];
  alerts: DashboardAlertItem[];
}

/**
 * Busca os dados consolidados de telemetria e analytics para o período solicitado.
 */
export async function fetchDashboardAnalytics(
  token: string,
  period: '1h' | 'today' | '7d' | '30d' = 'today'
): Promise<DashboardAnalyticsResponse> {
  const response = await fetch(
    `${API_BASE_URL}/api/analytics/dashboard?period=${period}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error('Falha ao carregar métricas consolidadas do dashboard.');
  }

  return response.json();
}
